import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/shadcn/card';
import { cn } from '@/lib/utils';

interface WidgetCardShellProps {
    title: string;
    dragHandle?: ReactNode;
    actions?: ReactNode;
    className?: string;
    children: ReactNode;
}

/**
 * The exact visual chrome a widget renders in — title header + content body.
 * Shared by the sortable dashboard canvas (SortableWidgetCard) and the
 * builder's live preview (WidgetConfigSheet) so the two can never visually
 * drift apart: what you see while configuring is what lands on the dashboard.
 */
export default function WidgetCardShell({ title, dragHandle, actions, className, children }: WidgetCardShellProps) {
    return (
        <Card className={cn('h-full', className)}>
            <CardHeader className="flex flex-row items-center justify-between gap-2 space-y-0 pb-2">
                <div className="flex min-w-0 items-center gap-2">
                    {dragHandle}
                    <CardTitle className="truncate text-sm font-medium">{title}</CardTitle>
                </div>
                {actions && <div className="flex shrink-0 gap-1">{actions}</div>}
            </CardHeader>
            <CardContent>{children}</CardContent>
        </Card>
    );
}
